import styled from 'styled-components'

import SelectAntd from 'antd/lib/select'

export const Select = styled(SelectAntd)`
  width: 100%;
`
